// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"_2G7_M","smallLinkTypography":"zQTvu","titleTypography":"_1aRD2","cardTitleTypography":"_12n8t","nameCell":"_1DHP5","truncate":"_2UNUE","base":"_2Tvu5","subHeadingStyle":"_3Y3Ci","statusWarnings":"_2T-iw","statusSuccess":"XHzZ_","statusError":"_2UjpV","buttonAction":"_5f6MQ","buttonLeft":"T10Mb","buttonRight":"_3tm3c","buttonBorder":"_3rry6"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PartnerHierarchy/components/Hierarchy/HierarchyList.scss
// module id = 2688
// module chunks = 0